import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BatchFinancialUpdateModel extends BaseModel {
  reservation_uuids = []
  lot_handling_charge = null

  rules = {
    lot_handling_charge: 'required|numeric|max:10'
  };

  attributeLabels = {
    lot_handling_charge: i18n.t('Entry Fee'),
  };

  attributeHints = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
